import PropTypes from 'prop-types';
import { TrackingStatus } from '../enums/tracking-status';

export const TrackingSummaryPropType = PropTypes.shape({
  trackingNumber: PropTypes.string,
  url: PropTypes.string,
  status: PropTypes.oneOf(Object.values(TrackingStatus)),
  shipDate: PropTypes.string,
  deliveryDate: PropTypes.string,
});

/**
 * @typedef {object} TrackingSummaryPropType
 * @property {string} trackingNumber
 * @property {string} url
 * @property {(
 *   'UnTrackable'|
 *   'NotShipped'|
 *   'Delivered'|
 *   'DeliveryError'|
 *   'Shipped'
 * )} status
 * @property {string} shipDate
 * @property {string} deliveryDate
 */
